import { SETTINGS_SAVED_EVENT_NAME } from "../../calendar-common/constants";
import { persistSettings } from "../../calendar-common/helpers/settingsHelper";
import { updateSettingsFromStorage } from "../actions/settingsActions";

export const showSucessMessage = (store) => {
    store.setState({ showSuccessMessage: true });
    setTimeout(function () {
        store.setState({ showSuccessMessage: false });
    }, 3000);
};

export const openCalendarSettings = (store) => {
    const { config } = store.getState();

    if (!config.settingsOpenCloseEventName) return;

    const event = new Event(config.settingsOpenCloseEventName);
    document.dispatchEvent(event);
};

export const initSettingsListener = (store) => {
    document.addEventListener(
        SETTINGS_SAVED_EVENT_NAME,
        function (e) {
            let actualSettings = updateSettingsFromStorage(store);
            let settingsNoFilter = { ...{}, ...actualSettings };
            delete settingsNoFilter.filter;
            persistSettings(settingsNoFilter);
            if (!e.detail.noChangeView && e.detail.showAdvice)
                showSucessMessage(store);
        },
        false
    );
};
